import { Icon } from "./Icon.jsx";

// ─── INSTAGRAM CHIP ──────────────────────────────────────────────────────────
// The seller's Instagram is the one badge on a store that is a LINK and a reason to follow, so it is the only
// solid chip among the quiet outline badges (Verified, Ships in…, Free shipping): the accent colour fill with the
// Instagram glyph in its own small tile. Same palette as the rest of the site — no rainbow gradient.
//   onBanner  the chip sits on top of a seller's banner photo → white chip, ink text, so it never disappears
export function InstagramChip({ handle, onBanner = false, radius = 4, style }) {
  const h = String(handle || "").replace(/^@/, "").trim();
  if (!h) return null;
  const fill = onBanner ? "#FFFFFF" : "var(--pink-btn)";
  const ink = onBanner ? "var(--ink-on-light, #1B1814)" : "var(--on-accent)";
  return (
    <a href={`https://instagram.com/${h}`} target="_blank" rel="noreferrer" aria-label={`${h} on Instagram`}
      style={{ display: "inline-flex", alignItems: "center", gap: 7, background: fill, color: ink, borderRadius: radius, padding: "3px 11px 3px 4px", fontSize: 12, fontWeight: 700, textDecoration: "none", lineHeight: 1.3, boxShadow: onBanner ? "0 1px 6px rgba(0,0,0,0.25)" : "none", ...style }}>
      <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 22, height: 22, borderRadius: Math.max(2, radius - 1), background: onBanner ? "var(--pink-btn)" : "rgba(255,255,255,0.18)", color: onBanner ? "var(--on-accent)" : "inherit" }}>
        <Icon n="instagram" size={14} strokeWidth={1.8} />
      </span>
      @{h}
    </a>
  );
}
